import { render, staticRenderFns } from "./PitCardList.vue?vue&type=template&id=b2e9de24&scoped=true"
import script from "./PitCardList.vue?vue&type=script&lang=js"
export * from "./PitCardList.vue?vue&type=script&lang=js"
import style0 from "./PitCardList.vue?vue&type=style&index=0&id=b2e9de24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e9de24",
  null
  
)

export default component.exports